<!--
 * @Description: 合并线索 已投放的不能合并
 * @Author: cxh
 * @Date: 2022-05-07 17:55:14
 * @LastEditTime: 2023-06-26 10:28:52
 * @LastEditors: cxh
-->
<template>
  <div style="display: inline-block; margin-right: 10px">
    <a-button @click="showModal" v-bind="$attrs">{{ t('btn.merge') }}</a-button>
    <CosModal
      v-model:visible="visible"
      :title="t('custom.mergeCustormModalTitle')"
      :width="appId === 'customer' ? '1200px' : '780px'"
      @ok="handleSubmit"
      :confirmLoading="loading"
    >
      <a-alert :message="t('tips.mergeCustomModalTitle')" type="warning" show-icon />
      <ul class="list">
        <li v-for="(item, index) in data" :key="index">
          <p>{{ t('custom.AzbNzF') }}:</p>
          <p class="name flex1" :title="item[fieldNames.label]">{{ item[fieldNames.label] }}</p>
          <template v-if="appId === 'customer'">
            <p class="name" :title="item.customerCode" style="width: 300px">客户代码：{{ item.customerCode }}</p>
            <p class="name2" style="width: 160px">业务系统：{{ item.$sys || item.sys || '--' }}</p>
          </template>
          <p class="name" v-if="appId === 'cos_fbu' || appId === 'cos_ofbu'" style="width: 220px" :title="item.cosId">
            ID:{{ item.cosId }}
          </p>
          <p class="name" v-else style="width: 220px" :title="item[fieldNames.value]">
            ID：{{ item[fieldNames.value] }}
          </p>
        </li>
      </ul>
      <a-form :model="editForm" ref="formRef" v-if="visible">
        <a-form-item name="masterCosId" :label="t('custom.EgVAzB')" :rules="[{ required: true, message: '请选择' }]">
          <a-select v-model:value="editForm.masterCosId" :placeholder="t('common.pleaseSelect')">
            <a-select-option v-for="item in data" :key="item[fieldNames.value]"
              >{{ item[fieldNames.label] }}
              <span v-if="appId === 'cos_fbu' || appId === 'cos_ofbu'">({{ item.cosId }})</span>
              <span v-if="appId === 'customer'">({{ item.customerCode }})</span>
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </CosModal>
  </div>
</template>
<script lang="ts" setup>
import { ref } from 'vue'
import { DcMessage } from '@dc-platform/dc-components'
import { customerMerge as customerCustomerMerge } from '@/api/customer/index'
import { customerMerge as fbuCustomerMerge } from '@/api/gucangSales/customerCenter'
import { customerMerge as lbuCustomerMerge } from '@/api/yuntuSales/customerCenter'
import { customerMerge as ofbuCustomerMerge } from '@/api/overseasSales/customerCenter'
import type { PropType } from 'vue'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
interface Customer {
  cosId?: string
}
const props = defineProps({
  data: {
    type: Array as PropType<Customer[]>,
    default: () => {
      return []
    }
  },
  title: {
    type: String
  },
  tips: {
    type: String // 描述
  },
  fbuType: {
    type: Number, // 谷仓待合并客户所在阶段，2：潜在客户，3：签约客户，4：成交客户
    default: 2
  },
  appId: {
    type: String,
    default: 'cos_fbu'
  },
  fieldNames: {
    type: Object,
    default: () => {
      return { label: 'customerName', value: 'cosId' }
    }
  }
})
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref()
const editForm = ref<any>({})
const emit = defineEmits(['success'])
const customerMergeMethod = {
  cos_fbu: fbuCustomerMerge,
  cos_lbu: lbuCustomerMerge,
  cos_ofbu: ofbuCustomerMerge
}
const handleSubmit = () => {
  formRef.value?.validate().then(async () => {
    loading.value = true
    const { masterCosId } = editForm.value
    const subCosIds: any[] = []
    props.data.forEach((item) => {
      if (item.cosId !== masterCosId) {
        subCosIds.push(item.cosId)
      }
    })
    const p = {
      masterCosId,
      subCosIds
    }
    if (props.appId === 'customer') {
      customerCustomerMerge(p)
        .then(() => {
          visible.value = false
          emit('success')
          DcMessage.success(t('tips.mergeSuccess'))
        })
        .finally(() => {
          loading.value = false
        })
    } else {
      const params: any = {
        targetCosId: p.masterCosId,
        originalIdList: p.subCosIds
      }
      if (props.appId === 'cos_fbu') {
        params.stage = props.fbuType
      }
      customerMergeMethod[props.appId](params)
        .then(() => {
          visible.value = false
          emit('success')
          DcMessage.success(t('tips.mergeSuccess'))
        })
        .finally(() => {
          loading.value = false
        })
    }
  })
}
const showModal = () => {
  // 验证数量
  if (!props.data || props.data.length < 2) {
    DcMessage.error(t('tips.mergeSelectData'))
    return
  }
  visible.value = true
  editForm.value = {}
}
</script>
<style lang="scss" scoped>
.list {
  margin: 20px 0;
  li {
    display: flex;
    margin-bottom: 9px;
    .content {
      display: flex;
      align-items: center;
    }
  }
  .name {
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: 0;
    margin-right: 8px;
  }
  .name2 {
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 120px;
  }
}
.flex1 {
  flex: 1;
}
</style>
